module.exports = __webpack_public_path__ + "assets/831d5e1388534ade86ff3515d8bd0e22.svg";